<template>
  <input
    :value="value"
    @input="$emit('input', $event.target.value)"
    class="text-input"
    :class="{ active: !!value }"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      value: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.text-input {
  appearance: none;
  background-color: rgba(27, 7, 83, 0.08);
  border-radius: 10px;
  color: var(--white);
  font-size: 24px;
  line-height: 28px;
  padding: 22px 20px;

  &::placeholder {
    color: var(--white);
    font-style: italic;
  }

  &.active {
    background-color: var(--white);
    color: var(--black);
  }
}
</style>
